
export class Area {
    id: string;
    displayId: string;
    zoneId: string;
}
